export default __webpack_public_path__ + "static/back-cd1672bd7ecb6005c90d3f2c6ac47f0a.png";